export default "__VITE_ASSET__DhfJ8Bz0__"